<sidebar [title]="'Notificações'">
  <div class="side-notification-container">
    <header class="side-notification-header">
      <!-- <h3 class="" >Notificações</h3 > -->
      @if (notifications.length) {
      <h5 (click)="markAllAsRead()">Marcar todas como lidas</h5>
      }
    </header>
    <main>
      @if (notifications.length) {
      @for (notification of notifications; track notification) {
      <ng-container *ngTemplateOutlet="notificationTemplate; context: {notification: notification}"></ng-container>
      }
      } @else {
      <div class="not-notification">
        @if (loadingNotifications) {
        <app-loader-teste></app-loader-teste>
        <h4>Carregando notificações...</h4>
        } @else {
        <div class="empty">
          <img src="assets/images/turma-empty.png" alt="">
        </div>
        <h4>Não há nenhuma notificação</h4>
        }
      </div>
      }
    </main>
  </div>
</sidebar>

<ng-template #notificationTemplate let-notification="notification">
  <div class="notification" (click)="markAsRead(notification)">
    <span class="material-symbols-outlined">
      done_all
    </span>
    <div>
      <h4>{{ notification?.title }}</h4>
      <h6>{{ notification?.message }}</h6>
    </div>
  </div>
</ng-template>
